import { render, staticRenderFns } from "./AdminSnackbar.vue?vue&type=template&id=35077622&scoped=true"
import script from "./AdminSnackbar.vue?vue&type=script&lang=ts"
export * from "./AdminSnackbar.vue?vue&type=script&lang=ts"
import style0 from "./AdminSnackbar.vue?vue&type=style&index=0&id=35077622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35077622",
  null
  
)

export default component.exports